// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"b7758fd9","977":"5a8b65a0"}[chunkId] + ".chunk.js";
};